var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero section pb-0",class:[
			_vm.topOuterDivider && 'has-top-divider',
			_vm.bottomOuterDivider && 'has-bottom-divider',
			_vm.hasBgColor && 'has-bg-color',
			_vm.invertColor && 'invert-color' ]},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hero-inner section-inner",class:[
					_vm.topDivider && 'has-top-divider',
					_vm.bottomDivider && 'has-bottom-divider' ],staticStyle:{"padding-bottom":"2rem"}},[_c('div',{staticClass:"split-wrap",class:[
						_vm.invertMobile && 'invert-mobile',
						_vm.invertDesktop && 'invert-desktop',
						_vm.alignTop && 'align-top' ]},[_c('div',{staticClass:"split-item"},[_c('div',{staticClass:"hero-content split-item-content center-content-mobile"},[_c('h1',{staticClass:"mt-0 mb-16 reveal-fade",attrs:{"data-reveal-delay":"150"}},[_vm._v("\n\t\t\t\t\t\t\t\tSell products directly to developers\n\t\t\t\t\t\t\t")]),_c('p',{staticClass:"mt-0 mb-32 reveal-fade",attrs:{"data-reveal-delay":"300"}},[_vm._v("\n\t\t\t\t\t\t\t\tDiscover new prospects with rich data on millions of developers\n\t\t\t\t\t\t\t\tand start landing your ideal customers faster than ever.\n\t\t\t\t\t\t\t")]),_c('div',{staticClass:"reveal-fade",attrs:{"data-reveal-delay":"450"}},[_c('c-button',{staticClass:"mr-12 mb-12",attrs:{"tag":"a","wide-mobile":"","color":"dark"},on:{"click":_vm.showDataModal}},[_c('div',{staticStyle:{"display":"flex"}},[_c('span',{staticClass:"mr-12",staticStyle:{"font-family":"'Material Icons'","font-size":"14px"}},[_vm._v("table_chart")]),_c('span',[_vm._v("View sample")])])]),_c('c-button',{staticClass:"mr-12 mb-12",attrs:{"tag":"a","wide-mobile":"","color":"primary","href":"/signup"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('span',[_vm._v("Get started")]),_c('span',{staticClass:"ml-12",staticStyle:{"font-family":"'Material Icons'"}},[_vm._v("chevron_right")])])])],1)])])])])]),_c('modal',{attrs:{"name":"sample","adaptive":false,"scrollable":true,"transition":"bounce","width":"75%","height":"75%","styles":"overflow-x:scroll; background-color: #2B2B52; border-radius: 20px; padding: 20px; position: relative;\n                box-sizing: border-box;\n                margin: 0;\n                padding: 0;"}},[_c('div',{staticStyle:{"border-radius":"20px","padding-top":"20px","padding-right":"20px","padding-left":"20px","position":"sticky","top":"0px","left":"0px","background":"rgb(43, 43, 82)"}},[_c('c-image',{staticClass:"pb-12",staticStyle:{"display":"inline"},attrs:{"src":require('@/assets/images/github.png'),"width":48,"height":48}}),_c('span',{staticClass:"text-md",staticStyle:{"font-family":"monospace","color":"white"}},[_c('b',[_vm._v("\n                            hooli/box3\n                        ")])])],1),_c('table-component',{attrs:{"min-rows":100000000,"data":[{
                        "username": "dnetting0",
                        "first_name": "Dorey",
                        "last_name": "Netting",
                        "email": "dnetting0@who.int",
                        "fork": true,
                        "watcher": false,
                        "contributor": true,
                        "language": "Javascript",
                        "time_zone": "Asia/Manila",
                        "last_commit": "08/22/2018"
                        }, {
                        "username": "wdominick1",
                        "first_name": "Wiatt",
                        "last_name": "Dominick",
                        "email": "wdominick1@quantcast.com",
                        "fork": false,
                        "watcher": true,
                        "contributor": false,
                        "language": "Ruby",
                        "time_zone": "Europe/Lisbon",
                        "last_commit": "06/07/2019"
                        }, {
                        "username": "eyerborn2",
                        "first_name": "Esra",
                        "last_name": "Yerborn",
                        "email": "eyerborn2@g.co",
                        "fork": true,
                        "watcher": true,
                        "contributor": false,
                        "language": "Go",
                        "time_zone": "Asia/Harbin",
                        "last_commit": "01/26/2021"
                        }, {
                        "username": "mosbiston3",
                        "first_name": "Mohammed",
                        "last_name": "Osbiston",
                        "email": "mosbiston3@mysql.com",
                        "fork": true,
                        "watcher": true,
                        "contributor": false,
                        "language": "Objective-C",
                        "time_zone": "Europe/Ljubljana",
                        "last_commit": "12/15/2019"
                        }, {
                        "username": "frubinsaft4",
                        "first_name": "Farica",
                        "last_name": "Rubinsaft",
                        "email": "frubinsaft4@privacy.gov.au",
                        "fork": false,
                        "watcher": false,
                        "contributor": true,
                        "language": "SQL",
                        "time_zone": "Europe/Paris",
                        "last_commit": "03/03/2019"
                        }, {
                        "username": "ebiagi5",
                        "first_name": "Eddie",
                        "last_name": "Biagi",
                        "email": "ebiagi5@foxnews.com",
                        "fork": true,
                        "watcher": true,
                        "contributor": true,
                        "language": "Ruby",
                        "time_zone": "Asia/Bangkok",
                        "last_commit": "09/04/2018"
                        }, {
                        "username": "bdixon6",
                        "first_name": "Berty",
                        "last_name": "Dixon",
                        "email": "bdixon6@hibu.com",
                        "fork": false,
                        "watcher": false,
                        "contributor": true,
                        "language": "Python",
                        "time_zone": "Asia/Tokyo",
                        "last_commit": "07/05/2020"
                        }, {
                        "username": "spannett7",
                        "first_name": "Sammie",
                        "last_name": "Pannett",
                        "email": "spannett7@liveinternet.ru",
                        "fork": false,
                        "watcher": true,
                        "contributor": true,
                        "language": "Objective-C",
                        "time_zone": "Asia/Makassar",
                        "last_commit": "06/10/2018"
                        }, {
                        "username": "tsauntf",
                        "first_name": "Taber",
                        "last_name": "Saunt",
                        "email": "tsauntf@arizona.edu",
                        "fork": false,
                        "watcher": false,
                        "contributor": false,
                        "language": "SQL",
                        "time_zone": "Europe/Belgrade",
                        "last_commit": "08/12/2019"
                        }, {
                        "username": "ctregienh",
                        "first_name": "Charmion",
                        "last_name": "Tregien",
                        "email": "ctregienh@amazon.de",
                        "fork": true,
                        "watcher": true,
                        "contributor": true,
                        "language": "Go",
                        "time_zone": "Asia/Jakarta",
                        "last_commit": "12/17/2017"
                        }, {
                        "username": "sbanghei",
                        "first_name": "Sascha",
                        "last_name": "Banghe",
                        "email": "sbanghei@paginegialle.it",
                        "fork": false,
                        "watcher": false,
                        "contributor": false,
                        "language": "HTML",
                        "time_zone": "Europe/Zurich",
                        "last_commit": "03/03/2017"
                        }]}},[_c('table-column',{attrs:{"show":"username","label":"Username"}}),_c('table-column',{attrs:{"show":"first_name","label":"First Name"}}),_c('table-column',{attrs:{"show":"last_name","label":"Last Name"}}),_c('table-column',{attrs:{"show":"email","label":"Email"}}),_c('table-column',{attrs:{"show":"fork","label":"Fork"}}),_c('table-column',{attrs:{"show":"watcher","label":"Watcher"}}),_c('table-column',{attrs:{"show":"contributor","label":"Contributor"}}),_c('table-column',{attrs:{"show":"language","label":"Language"}}),_c('table-column',{attrs:{"show":"time_zone","label":"Time Zone"}}),_c('table-column',{attrs:{"show":"last_commit","label":"Last Commit","data-type":"date:MM/DD/YYYY"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }